import { Popover } from "@mui/material";
import {
  Box,
  Divider,
  IconButton,
  List,
  ListItem,
  ListItemText,
  Tooltip,
  Typography,
} from "../../../../components";
import { useMemo, useState } from "react";

const emojis = [
  { emoji: "ph-fill ph-smiley-angry", label: "Muito insatisfeito", color: "#eb5a5a" },
  { emoji: "ph-fill ph-smiley-sad", label: "Insatisfeito", color: "#f48a00" },
  { emoji: "ph-fill ph-smiley-meh", label: "Neutro", color: "#fbbc05" },
  { emoji: "ph-fill ph-smiley", label: "Satisfeito", color: "#5D8E3C" },
  { emoji: "ph-fill ph-smiley-wink", label: "Muito satisfeito", color: "#164221" },
];

export default function ListPesquisaSatisfacaoOS({ listaOrdemServicoPesquisas }) {
  const emojiColor = useMemo(() => {
    if (listaOrdemServicoPesquisas?.length) {
      const respostasValidas = listaOrdemServicoPesquisas
        .map((p) => Number(p.resposta))
        .filter((n) => !Number.isNaN(n) && n >= 1 && n <= 5);

      if (respostasValidas.length === 0) {
        return { emoji: "ph-fill ph-smiley", color: "#5D8E3C" };
      }
      const somaInversos = respostasValidas.reduce((acc, n) => acc + 1 / n, 0);
      const nota = respostasValidas.length / somaInversos;
      const emojiCor = Math.min(5, Math.max(1, Math.round(nota)));

      return {
        emoji: emojis[emojiCor - 1].emoji,
        label: emojis[emojiCor - 1].label,
        color: emojis[emojiCor - 1].color,
      };
    }
    return { emoji: "ph-fill ph-smiley", color: "#5D8E3C" };
  }, [listaOrdemServicoPesquisas]);

  const [anchorElPesquisa, setAnchorElPesquisa] = useState(null);
  const openPesquisa = Boolean(anchorElPesquisa);
  const idPesquisaPopover = openPesquisa ? "popover-pesquisa" : undefined;

  const handleOpenPesquisaPopover = (event) => setAnchorElPesquisa(event.currentTarget);
  const handleClosePesquisaPopover = () => setAnchorElPesquisa(null);

  const mapRespostaToLabel = (resposta) => {
    if (resposta == null) return { emoji: null, label: "" };
    const n = Number(resposta);
    if (!Number.isNaN(n) && n >= 1 && n <= 5) {
      return { emoji: emojis[n - 1].emoji, label: emojis[n - 1].label, color: emojis[n - 1].color };
    }
    return { emoji: null, label: String(resposta) };
  };

  return (
    <>
      <Tooltip title="Pesquisa de satisfação" arrow placement="left">
        <IconButton
          aria-describedby={idPesquisaPopover}
          onClick={handleOpenPesquisaPopover}
          sx={{ ml: 0.5 }}
        >
          <i className={emojiColor?.emoji} style={{ fontSize: 19, color: emojiColor?.color }}></i>
        </IconButton>
      </Tooltip>
      <Popover
        id={idPesquisaPopover}
        open={openPesquisa}
        anchorEl={anchorElPesquisa}
        onClose={handleClosePesquisaPopover}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
        slotProps={{
          paper: { sx: { borderRadius: 4, p: 1, maxHeight: "60vh", overflowY: "auto", width: 340 } },
        }}
      >
        <Box sx={{ width: "100%", maxWidth: 340, p: 1 }}>
          <Typography variant="subtitle1" sx={{ fontWeight: 600, mb: 0.5 }}>
            Pesquisa de Satisfação
          </Typography>
          {listaOrdemServicoPesquisas?.length ? (
            <Typography variant="body2" sx={{ color: "text.secondary", mb: 1 }}>
              {`Respondida em ${new Date(listaOrdemServicoPesquisas[0].createdAt).toLocaleDateString("pt-BR")}`}
            </Typography>
          ) : null}
          {listaOrdemServicoPesquisas?.length === 0 ? (
            <Typography variant="body2" sx={{ color: "text.secondary" }}>
              Nenhuma pesquisa respondida.
            </Typography>
          ) : (
            <List dense>
              {listaOrdemServicoPesquisas.map((p, idx) => {
                const { emoji, label, color } = mapRespostaToLabel(p.resposta);
                return (
                  <Box key={idx}>
                    <ListItem alignItems="center">
                      <ListItemText
                        primary={p.pergunta}
                        secondary={
                          <Box
                            className="d-flex align-items-center gap-2 px-2 py-2 mt-2"
                            sx={{
                              background: color ? color + "35" : "#f0f0f0ff",
                              borderRadius: 1,
                              pl: 1,
                              overflowWrap: "anywhere",
                            }}
                          >
                            <Box sx={{ display: "flex", alignItems: "center" }}>
                              <i className={emoji} style={{ fontSize: 20, marginRight: 4, color }}></i>
                            </Box>
                            <Box sx={{ flex: 1 }}>{label}</Box>
                          </Box>
                        }
                      />
                    </ListItem>
                    {idx < listaOrdemServicoPesquisas.length - 1 ? (
                      <Divider variant="fullWidth" component="li" />
                    ) : null}
                  </Box>
                );
              })}
            </List>
          )}
        </Box>
      </Popover>
    </>
  );
}
